module.exports = __webpack_public_path__ + "img/nrg.d380029d.png";